import { Injectable } from '@angular/core';
import { LocalStorageService } from '@core/auth/services/local-storage/local-storage.service';

export interface InRent {
  order_id: number;
  trailer_id: number;

}

@Injectable({
  providedIn: 'root'
})
export class InRentTrailerService extends LocalStorageService<InRent> {

  constructor () {
    super('IN_RENT_TRAILER');
  }

  save(inRentData: InRent) {
    this.value = inRentData;
  }
}
